interface SchemaInputProps {
    value: string
    placeholder: string
    onChange: (value: string) => void
}

const SchemaInput = ({value, placeholder, onChange}: SchemaInputProps) => {
    return (
        <textarea className="w-1/2 h-full p-4 m-2 border border-gray-300 resize-none" placeholder={placeholder}
        value={value}
        onChange={e => onChange(e.target.value)}
      />
    )
}

export default SchemaInput;